import { TFunction } from 'i18next';

export const getClassicSelectedOptions = (
  t: TFunction<'workflow-builder-preview'>,
) => [
  { disabled: true, label: t('common.mixed'), value: '' },
  { label: t('common.published'), value: 'published' },
  { label: t('common.draft'), value: 'draft' },
];

export const getAgentSelectedOptions = (
  t: TFunction<'workflow-builder-preview'>,
) => [
  { label: t('intentFilterRow.active'), value: 'active' },
  { label: t('intentFilterRow.inactive'), value: 'inactive' },
  { label: t('constants.options.allAgents'), value: 'all' },
];

export const getStateSelectedOptions = (
  t: TFunction<'workflow-builder-preview'>,
) => [
  { disabled: true, label: t('common.mixed'), value: '' },
  { label: t('constants.options.live'), value: 'live' },
  { label: t('constants.options.autoSaved'), value: 'auto-saved' },
  { label: t('constants.options.offline'), value: 'offline' },
  { label: t('constants.options.all'), value: 'all' },
];

export const darkModeBlue = '#42A4FF';

export const darkModeGreen = '#29CF26';

export const darkModeGrey = '#AABBCA';

export const darkModePurple = '#DE82FF';

export const darkModeOrange = '#FD9A4E';

export const autoflowColors = {
  dark: {
    agentResponse: darkModeOrange,
    agentThoughts: darkModeGrey,
    default: darkModeBlue,
    userQuery: darkModeGreen,
  },
};

export const INTENT_NOT_PREDICTED = 'intent_not_predicted';
